<!-- eslint-disable max-len -->
<template>
  <svg
    v-if="type === 'speaking'"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip-speaking)">
      <path
        fill="currentColor"
        d="M12.5 15.834c0-.663-.264-1.3-.732-1.768a2.5 2.5 0 0 0-1.52-.72L10
        13.334H4.167a2.5 2.5 0 0 0-2.5 2.5v1.666H0v-1.666a4.167 4.167
        0 0 1 4.167-4.167H10a4.167 4.167 0 0 1 4.167 4.167v1.666H12.5v-1.666z
        M17.559 5.43a6.667 6.667 0 0 1-.002 5.812l-.416.723-1.444-.831.415-.723a5
        5 0 0 0 .555-2.075l-.01-.273a5 5 0 0 0-.544-1.803l-.415-.723 1.445-.83.416.723z
        M13.749 8.335c0-.218-.057-.433-.166-.623l-.415-.723 1.445-.83.415.723a2.917
        2.917 0 0 1 0 2.906l-.415.723-1.445-.83.415-.723c.109-.19.166-.404.166-.623z
        M9.571 5.586a2.917 2.917 0 0 0-4.988 0 2.917 2.917 0 0 0 4.988 0z
        M11.245 6.04a4.583 4.583 0 1 1-8.329-.207 4.583 4.583 0 0 1 8.33.207z"
      />
    </g>
    <defs>
      <clipPath id="clip-speaking">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else-if="type === 'listening' || type === 'atis'"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M7.5 17.5H4.167a1.667 1.667 0 0 1-1.667-1.667V10a7.5
      7.5 0 0 1 15 0v5.833a1.667 1.667 0 0 1-1.667 1.667H12.5v-6.667h3.333V10a5.833
      5.833 0 0 0-11.666 0v.833H7.5v6.667zM5.833 12.5H4.167v3.333h1.666V12.5z
      M14.167 12.5v3.333h1.666V12.5h-1.666z"
    />
  </svg>

  <svg
    v-else-if="type === 'describing'"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M4.167 17.5a1.667 1.667 0 0 1-1.667-1.667V4.167c0-.458.163-.851.49-1.177.327-.326.719-.49
      1.177-.49h11.666c.459 0 .851.163 1.178.49.326.327.49.719.49 1.177v11.666c0
      .459-.164.851-.49 1.178-.327.326-.72.49-1.178.49H4.167zm0-1.667h11.666V4.167H4.167v11.666z
      M5.833 14.167h8.334a.417.417 0 0 0 .375-.23.417.417 0 0 0-.042-.437l-2.292-3.063a.417.417
      0 0 0-.625 0L9.375 13.333l-1.542-2.062a.417.417 0 0 0-.666 0L5.5 13.5a.417.417 0 0 0-.042.438c.084.152.209.229.375.229z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ModuleTypeIcon',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
